/**
 * ChatHomePage (PWA-3, orden 6c634438) — home del CLIENTE: el chat-agente como
 * SUPERFICIE PRIMARIA, a pantalla completa. Reusa el ChatPanel en modo `embedded`
 * (cero duplicación): mismo chat-agente (tool-use, scopeado, no-invent), mismo
 * visor de informes (AF) y render. Se monta solo en hosts de cliente (App.tsx por
 * host); en el Arquitecto la home sigue siendo el dashboard.
 */
import { ChatPanel } from '@/components/ChatPanel'

export function ChatHomePage() {
  return (
    // Mobile-first DIÁFANO: en móvil ocupa toda la pantalla (full-bleed — anula el padding
    // del main y la mini-topbar), sin marco. En escritorio: tarjeta acotada con relieve por
    // sombra (sin borde/línea — estética vinculante del operador: relieves+sombras, no líneas).
    <div className="-m-3 h-[calc(100dvh-3.25rem)] overflow-hidden bg-background sm:m-0 sm:h-[calc(100dvh-8rem)] sm:rounded-2xl sm:bg-card sm:shadow-lg">
      <ChatPanel embedded />
    </div>
  )
}

export default ChatHomePage
